export function openPdfResponse(response, { title = 'PDF', onClose, downloadFileName } = {}) {
    if (!response) {
        return null;
    }
    const payload = response instanceof Blob
        ? response
        : (response.data instanceof Blob ? response.data : response);
    const pdfBlob = payload instanceof Blob
        ? payload
        : new Blob([payload], { type: 'application/pdf' });
    return openPdfInApp(pdfBlob, { title, onClose, downloadFileName });
}

export function openPdfInApp(blob, { title = 'Invoice PDF', onClose, downloadFileName } = {}) {
    if (!blob) {
        return null;
    }

    const pdfBlob = blob instanceof Blob ? blob : new Blob([blob], { type: 'application/pdf' });
    const fileURL = URL.createObjectURL(pdfBlob);

    const existing = document.querySelector('.invoice-pdf-overlay');
    if (existing) {
        existing.remove();
    }

    const overlay = document.createElement('div');
    overlay.className = 'invoice-pdf-overlay';
    overlay.innerHTML = `
        <div class="invoice-pdf-panel" role="dialog" aria-label="${title}">
            <div class="invoice-pdf-toolbar">
                <span class="invoice-pdf-title">${title}</span>
                <div class="invoice-pdf-toolbar-actions">
                    <button type="button" class="invoice-pdf-print btn btn-outline-light">Print</button>
                    ${downloadFileName ? '<button type="button" class="invoice-pdf-download btn btn-outline-light">Download</button>' : ''}
                    <button type="button" class="invoice-pdf-close btn btn-primary">Back to application</button>
                </div>
            </div>
            <iframe class="invoice-pdf-frame" src="${fileURL}" title="${title}"></iframe>
        </div>
    `;

    const close = () => {
        URL.revokeObjectURL(fileURL);
        overlay.remove();
        onClose?.();
    };

    overlay.querySelector('.invoice-pdf-close').addEventListener('click', close);
    overlay.querySelector('.invoice-pdf-print').addEventListener('click', () => {
        const frame = overlay.querySelector('.invoice-pdf-frame');
        frame?.contentWindow?.focus();
        frame?.contentWindow?.print();
    });
    const downloadButton = overlay.querySelector('.invoice-pdf-download');
    if (downloadButton && downloadFileName) {
        downloadButton.addEventListener('click', () => {
            const link = document.createElement('a');
            link.href = fileURL;
            link.download = downloadFileName;
            link.click();
        });
    }
    overlay.addEventListener('click', (event) => {
        if (event.target === overlay) {
            close();
        }
    });

    document.body.appendChild(overlay);
    return close;
}

export function openHtmlInApp(html, { title = 'Preview', onClose } = {}) {
    if (!html) {
        return null;
    }

    const existing = document.querySelector('.invoice-pdf-overlay');
    if (existing) {
        existing.remove();
    }

    const overlay = document.createElement('div');
    overlay.className = 'invoice-pdf-overlay';
    overlay.innerHTML = `
        <div class="invoice-pdf-panel" role="dialog" aria-label="${title}">
            <div class="invoice-pdf-toolbar">
                <span class="invoice-pdf-title">${title}</span>
                <div class="invoice-pdf-toolbar-actions">
                    <button type="button" class="invoice-pdf-print btn btn-outline-light">Print</button>
                    <button type="button" class="invoice-pdf-close btn btn-primary">Back to application</button>
                </div>
            </div>
            <iframe class="invoice-pdf-frame" title="${title}"></iframe>
        </div>
    `;

    const frame = overlay.querySelector('.invoice-pdf-frame');
    frame.srcdoc = html;

    const close = () => {
        overlay.remove();
        onClose?.();
    };

    overlay.querySelector('.invoice-pdf-close').addEventListener('click', close);
    overlay.querySelector('.invoice-pdf-print').addEventListener('click', () => {
        frame.contentWindow?.focus();
        frame.contentWindow?.print();
    });
    overlay.addEventListener('click', (event) => {
        if (event.target === overlay) {
            close();
        }
    });

    document.body.appendChild(overlay);
    return close;
}
